var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHexagonRightCorner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 341.1 499.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "64.3 37.3 64.1 97.9 117.3 128.4 170.8 98.3 171 37.7 117.7 7.2 64.3 37.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "117.7 7.2 64.3 37.3 64.1 97.9 90.7 82.9 90.9 52.6 117.6 37.4 117.7 7.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "144.2 22.4 90.8 52.6 90.6 113.2 117.3 98.1 117.4 67.8 144.1 52.8 144.2 22.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "171 37.7 117.5 67.8 117.3 128.4 170.8 98.3 171 37.7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "117.5 128.4 117.3 189 170.5 219.4 224 189.3 224.2 128.7 170.9 98.3 117.5 128.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "170.9 98.3 117.5 128.4 117.3 189 143.9 174 144.1 143.6 170.8 128.5 170.9 98.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "197.4 113.5 144 143.6 143.8 204.2 170.5 189.2 170.6 158.9 197.4 143.9 197.4 113.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "224.2 128.7 170.7 158.9 170.5 219.4 224 189.3 224.2 128.7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.8 128.4 10.6 189 63.8 219.4 117.3 189.3 117.5 128.7 64.2 98.3 10.8 128.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "64.2 98.3 10.8 128.4 10.6 189 37.2 174 37.4 143.6 64.1 128.5 64.2 98.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.8 113.5 37.3 143.6 37.1 204.2 63.8 189.2 64 158.9 90.7 143.9 90.8 113.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "117.5 128.7 64 158.9 63.8 219.4 117.3 189.3 117.5 128.7"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "170.7 219.5 170.5 280.1 223.8 310.5 277.2 280.4 277.4 219.8 224.2 189.3 170.7 219.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "224.2 189.3 170.7 219.5 170.5 280.1 197.1 265.1 197.3 234.7 224.1 219.6 224.2 189.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "250.7 204.6 197.2 234.7 197 295.3 223.8 280.2 223.9 249.9 250.6 234.9 250.7 204.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "277.4 219.8 224 249.9 223.8 310.5 277.2 280.4 277.4 219.8"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.9 219.3 63.7 279.9 117 310.4 170.4 280.2 170.6 219.7 117.4 189.2 63.9 219.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "117.4 189.2 63.9 219.3 63.7 279.9 90.4 264.9 90.6 234.6 117.3 219.4 117.4 189.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "143.9 204.4 90.5 234.6 90.3 295.1 117 280.1 117.1 249.8 143.8 234.8 143.9 204.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "170.6 219.7 117.2 249.8 117 310.4 170.4 280.2 170.6 219.7"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "224.1 310.5 223.9 371.1 277.1 401.6 330.6 371.4 330.8 310.8 277.5 280.4 224.1 310.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "277.5 280.4 224.1 310.5 223.9 371.1 250.5 356.1 250.7 325.7 277.4 310.6 277.5 280.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "304 295.6 250.6 325.7 250.4 386.3 277.1 371.3 277.2 341 303.9 326 304 295.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "330.8 310.8 277.3 341 277.1 401.6 330.6 371.4 330.8 310.8"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "117.1 310.4 116.9 371 170.2 401.5 223.6 371.3 223.8 310.8 170.6 280.3 117.1 310.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "170.6 280.3 117.1 310.4 116.9 371 143.6 356 143.8 325.6 170.5 310.5 170.6 280.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "197.1 295.5 143.7 325.6 143.5 386.2 170.2 371.2 170.3 340.9 197 325.9 197.1 295.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.8 310.8 170.4 340.9 170.2 401.5 223.6 371.3 223.8 310.8"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.5 310.2 10.3 370.8 63.6 401.3 117 371.2 117.2 310.6 63.9 280.1 10.5 310.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.9 280.1 10.5 310.2 10.3 370.8 36.9 355.8 37.1 325.5 63.8 310.3 63.9 280.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.5 295.3 37 325.5 36.8 386 63.5 371 63.7 340.7 90.4 325.7 90.5 295.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "117.2 310.6 63.8 340.7 63.6 401.3 117 371.2 117.2 310.6"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "170.5 401.5 170.3 462.1 223.5 492.6 277 462.4 277.2 401.8 223.9 371.4 170.5 401.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.9 371.4 170.5 401.5 170.3 462.1 196.9 447.1 197.1 416.7 223.8 401.6 223.9 371.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "250.4 386.6 197 416.7 196.8 477.3 223.5 462.3 223.6 432 250.3 417 250.4 386.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "277.2 401.8 223.7 432 223.5 492.6 277 462.4 277.2 401.8"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.8 401.4 63.6 462 116.8 492.5 170.3 462.4 170.5 401.8 117.2 371.3 63.8 401.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "117.2 371.3 63.8 401.4 63.6 462 90.2 447 90.4 416.7 117.1 401.5 117.2 371.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "143.8 386.5 90.3 416.7 90.1 477.3 116.8 462.2 116.9 431.9 143.7 416.9 143.8 386.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "170.5 401.8 117 431.9 116.8 492.5 170.3 462.4 170.5 401.8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonRightCorner);
export default __webpack_public_path__ + "static/media/hexagon-right-corner.ecd1e905c84581482dd9da12d8cf7290.svg";
export { ForwardRef as ReactComponent };